/* tslint:disable */
/* eslint-disable */
export enum CatalogLookupType {
  Instruction = 'INSTRUCTION',
  Modifier = 'MODIFIER',
  Product = 'PRODUCT',
  Composite = 'COMPOSITE'
}
